export const API = {
    // 获取ws token
    GetWsToken: 'GetWsToken',
    // 获取client 中获取ws token以及baseinfo
    GetSharePageWsToken: 'GetSharePageWsToken',
    DescribeAppDebugConfig: 'DescribeAppDebugConfig',
    SaveAppDebugConfig: 'SaveAppDebugConfig',
    SaveAppDebugMode: 'SaveAppDebugMode',
    // 获取最近联系人
    GetRecentContact: 'GetRecentContact',
    // 重置会话
    ResetSession: 'ResetSession',
    // 获取机器人详情
    DescribeRobotInfo: 'DescribeRobotInfo',
    // 获取单条聊天记录
    GetSingleMsgRecord: 'GetSingleMsgRecord',
    // 获取推荐问题
    GetRecommendQuestion: 'GetRecommendQuestion',
    // 创建会话
    CreateSession: 'CreateSession',
    // 获取聊天历史请求
    GetMsgRecord: 'GetMsgRecord',
    // 获取机器人转人工状态
    GetTransferStatus: 'GetTransferStatus',
    // 获取文件上传临时密钥
    DescribeStorageCredential: 'DescribeStorageCredential',
    // 模型详情
    DescribeModel: 'DescribeModel',
    // 获取对外显示文档列表
    GetDisplayDocs: 'GetDisplayDocs',
    // 获取文档预览地址
    GetDocPreview: 'GetDocPreview',
    // 获取应用模型可输入字符的数量限制
    GetAppChatInputNum: 'GetAppChatInputNum',
    // 获取应用密钥
    GetAppSecret: 'GetAppSecret',
    // 获取反馈原因
    ListFeedbackReason: 'ListFeedbackReason',
    DescribeApp: 'DescribeApp',
    // 获取模型列表
    ListModel: 'ListModel',
    // 获取来源详情列表
    DescribeRefer: 'DescribeRefer',
    // 获取用户应用配置-开启联网搜索
    GetUserDialogConfig: 'GetUserDialogConfig',
    // 修改用户应用配置-开启联网搜索
    ModifyUserDialogConfig: 'ModifyUserDialogConfig',
    GetRTCToken: 'GetRTCToken',
    StartRTCConversation: 'StartRTCConversation',
    StopRTCConversation: 'StopRTCConversation',
    GetTempCredential: 'GetTempCredential',
    GetTTSSignature: 'GetTTSSignature',
    GetSharePageTTSSignature: 'GetSharePageTTSSignature',
    GetSharePageRTCToken: 'GetSharePageRTCToken',
    GetSharePageTempCredential: 'GetSharePageTempCredential',
    // http请求异步任务 创建工作流运行实例
    CreateWorkflowRun: 'CreateWorkflowRun',
    // 获取图片上传地址
    GetImagePreview: 'GetImagePreview',
    // 获取异步list
    ListWorkflowRuns: 'ListWorkflowRuns',
    GetDigitalHumanSignature: 'GetDigitalHumanSignature',
    GetSharePageDigitalHumanSignature: 'GetSharePageDigitalHumanSignature',
    //  tcdoc 腾讯文档接入 start
    // https://capi.woa.com/api/detail?product=lke&version=2023-11-30&action=GetTFolder
    // https://capi.woa.com/api/detail?product=lke&version=2023-11-30&action=CheckUserAuth
    // https://capi.woa.com/api/detail?product=lke&version=2023-11-30&action=ImportTFileProgress
    // https://capi.woa.com/api/detail?product=lke&version=2023-11-30&action=ImportTFile
    GetTFolder: 'GetTFolder',
    CheckUserAuth: 'CheckUserAuth',
    ImportTFileProgress: 'ImportTFileProgress',
    ImportTFile: 'ImportTFile',
    // tcdoc 腾讯文档接入 end
    CheckWhitelist: 'CheckWhitelist'
};



// WEBPACK FOOTER //
// ./src/utils/api.js